import cx from 'classnames';
import { Button } from 'components/admin/ui/Button';
import { Modal } from 'components/ui/Modal';
import { ReactNode } from 'react';
import { ModalProps } from 'react-bootstrap';
import css from './ConfirmationModal.module.scss';

interface IConfirmationModalProps extends ModalProps {
  className?: string;
  confirmButtonLabel: string;
  icon: ReactNode;
  isConfirmDisabled?: boolean;
  isVisible: boolean;
  onConfirm: () => void;
  onHide: () => void;
  title: string;
  iconColor: 'blue' | 'gray' | 'red' | 'yellow';
  alternativeButtonLabel?: string;
  onAlternativeConfirm?: () => void;
}

/**
 * @deprecated
 * This component should be replaced by the new `ConfirmationModal` component, currently located in the `admin` domain.
 **/
export const ConfirmationModal = ({
  children,
  className,
  confirmButtonLabel,
  icon,
  isConfirmDisabled,
  isVisible,
  onConfirm,
  onHide,
  title,
  iconColor,
  alternativeButtonLabel,
  onAlternativeConfirm,
  ...rest
}: IConfirmationModalProps) => (
  <Modal
    show={isVisible}
    className={cx(css.confirmationModal, className)}
    hasCloseButton={false}
    backdropClassName={css.confirmationModalBackdrop}
    {...rest}
  >
    <Modal.Header>
      <div className={cx(css.iconWrapper, css[iconColor])}>{icon}</div>
    </Modal.Header>
    <Modal.Body className={cx(css.confirmationModalBody)}>
      <h2 className={cx(css.heading)}>{title}</h2>
      {children}
    </Modal.Body>
    <Modal.Footer>
      <div className={css.buttonContainer}>
        <div>
          {alternativeButtonLabel && (
            <Button
              color="red"
              onClick={onAlternativeConfirm}
              variant="outline"
            >
              {alternativeButtonLabel}
            </Button>
          )}
        </div>
        <div>
          <Button onClick={onHide} variant="outline">
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            isDisabled={isConfirmDisabled}
            variant="solid"
            color="blue"
          >
            {confirmButtonLabel || 'Confirm'}
          </Button>
        </div>
      </div>
    </Modal.Footer>
  </Modal>
);
